import { useState, SyntheticEvent } from "react"
import { ThemeProvider } from "@mui/material"
import { MetricBlueprintTabsWrapper, theme } from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import { setSelectedTab } from "../../../redux/slices/metricSlice"
import DraggableTabs from "../Reusable/DraggableTabs"
import BucketConfirmation from "../../Modal/BucketConfirmation"
import { SimpleConfirmation } from "../../Modal/Reusable"

type NewBucket = {
  bucketName: string
}

type EditBucket = {
  oldBucketName: string
  newBucketName: string
  bucketId: number | null
}

type DelBucket = {
  bucketName: string
  bucketId: number | null
}

export default function MetricBlueprintTabs({
  addNewBucket,
  fetchMetricTabs,
  updateBucketName,
  deleteBucket,
}: any) {
  const dispatch = useDispatch()

  const tabs = useSelector((state: any) => {
    return state.metric.tabs
  })

  const [value, setValue] = useState("1")

  const [type, setType] = useState("")
  const [open, setOpen] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const [newBucket, setNewBucket] = useState<NewBucket>({ bucketName: "" })
  const [editBucket, setEditBucket] = useState<EditBucket>({
    oldBucketName: "",
    newBucketName: "",
    bucketId: null,
  })
  const [delBucket, setDelBucket] = useState<DelBucket>({
    bucketName: "",
    bucketId: null,
  })

  const handleChange = (event: SyntheticEvent, newValue: any) => {
    setValue(newValue)
    dispatch(setSelectedTab(newValue))
  }

  const handleBucketCreateOpen = async () => {
    setType("new")
    setOpen(true)
  }

  const handleBucketUpdateOpen = (oldBucketName: any, bucketId: any) => {
    setType("edit")
    setEditBucket({
      ...editBucket,
      oldBucketName: oldBucketName,
      bucketId: bucketId,
    })
    setOpen(true)
  }

  const handleBucketDeleteOpen = async (
    bucketName: string,
    bucketId: number,
  ) => {
    setDelBucket({ bucketName: bucketName, bucketId: bucketId })
    setDeleteModalOpen(true)
  }

  const handleBucketDelete = async () => {
    await deleteBucket(delBucket?.bucketId)
  }

  return (
    <>
      <BucketConfirmation
        open={open}
        setOpen={setOpen}
        type={type}
        newBucket={newBucket}
        setNewBucket={setNewBucket}
        handleBucketAdd={addNewBucket}
        editBucket={editBucket}
        setEditBucket={setEditBucket}
        handleBucketUpdate={updateBucketName}
      />
      <SimpleConfirmation
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        title={`Delete Bucket`}
        optionalMessage={
          <>
            Do you want to delete the bucket <b>{delBucket?.bucketName}</b> ?
          </>
        }
        buttonText={`Delete`}
        confirmActionHandler={handleBucketDelete}
      />
      <ThemeProvider theme={theme}>
        {/* <MetricBlueprintTabsWrapper> */}
        <DraggableTabs
          tabs={tabs}
          value={value}
          handleChange={handleChange}
          handleBucketCreateOpen={handleBucketCreateOpen}
          handleBucketUpdateOpen={handleBucketUpdateOpen}
          handleBucketDeleteOpen={handleBucketDeleteOpen}
        />
        {/* </MetricBlueprintTabsWrapper> */}
      </ThemeProvider>
    </>
  )
}
